// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"691":"component---src-pages-index-tsx","883":"component---src-pages-404-js"}[chunkId] + "-" + {"691":"ca25ba3bb95457779412","883":"26ef82ae92853b6efdee"}[chunkId] + ".js";
};